export const MR_ACCURAL_ASSET_INFO = 'MR_ACCURAL_ASSET_INFO';
export const MR_ACCURAL_LIST_INFO = 'MR_ACCURAL_LIST_INFO';
export const MR_ACCRUAL_PROJECTION = 'MR_ACCRUAL_PROJECTION';
export const MR_ACCURAL_LOADER = 'MR_ACCURAL_LOADER';
export const ACCRUAL_PROGRAM_UPDATE = 'ACCRUAL_PROGRAM_UPDATE';
export const MR_ACCRUAL_CASH_FLOW = 'MR_ACCRUAL_CASH_FLOW';
export const CASH_FLOW_MONLTY_BREAKUP_LIST='CASH_FLOW_MONLTY_BREAKUP_LIST';
export const MONTHLY_TOGGLE_DATA='MONTHLY_TOGGLE_DATA';

